import { HttpHeaders, HttpParams } from '@angular/common/http';

export type PredicateFn<T = any> = (formValue?: any, formAction?: any) => T;
export type Primitive = string | number | boolean;
export interface IHttpOptions {
  headers?: HttpHeaders;
  params?: HttpParams;
}

export enum DecimalType {
  PLUS = 'plus',
  SUB = 'sub',
  MUL = 'mul',
  DIV = 'div',
  MOD = 'mod',
}

export interface HybridNumber {
  method?: DecimalType;
  number: numberOrString;
}

export type numberOrString = number | string;

/*
  module: module name
  matchFn: route matching rule, evaluated top to bottom
  navigateUrl: target route to redirect if matched
examples:
  - module: 'transfer'
    matchFn: (pathStr: string) => /^transfer(\/.*)?$/.test(pathStr)
    navigateUrl: PAGES_PATH.RequestTransferList
  - module: 'default'
    matchFn: () => true
    navigateUrl: DEFAULT_PATH
*/
export interface NavigateRule {
  matchFn: (path: string) => boolean;
  navigateUrl: string;
  module: string;
}
